import cn from 'classnames';
import { useMemo } from 'react';

import { calcNpsGradient, colorToRgba } from '@webapp/common/lib/color';

import css from './numbers-with-borders.css';

export const NumbersWithBorders: FC<{
    colors: Array<string>;
    itemsCount?: number;
    startsWith?: number;
    onClick?: (value: number) => void;
    selectedValue?: number;
    disabled?: boolean;
    className?: string;
}> = ({ colors, disabled, itemsCount = 11, onClick, selectedValue, startsWith = 0, className }) => {
    const gradient = useMemo(() => calcNpsGradient(colors, itemsCount), [colors, itemsCount]);

    return (
        <div className={cn(css.numbers, disabled && css.disabled)}>
            {gradient.map((color, index) => {
                const currentLabel = startsWith + index;
                const rgba = colorToRgba(color);

                return (
                    <div
                        style={{
                            color: color,
                            borderColor: color,
                            backgroundColor: rgba ? `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, 0.2)` : undefined,
                        }}
                        className={cn(
                            css.number,
                            selectedValue?.toString() === currentLabel.toString() && css.selectedNumber,
                            className,
                        )}
                        key={`${color}-${index}`}
                        onClick={onClick ? () => onClick(currentLabel) : undefined}
                    >
                        {currentLabel}
                    </div>
                );
            })}
        </div>
    );
};
